import React from 'react';

type SpeechBalloonProps = {
  type: string;
  content: string;
};

export function SpeechBalloon({ type, content }: SpeechBalloonProps) {
  return (
    <p className="speech-balloon">
      <dfn className="invisible">{type}: </dfn>
      <span className="speech-balloon__text">&bdquo;{content}&ldquo;</span>
    </p>
  );
}
